"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Anchor = require("./Anchor");

var _Anchor2 = _interopRequireDefault(_Anchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Anchor2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-anchor@0.0.6@@alicd/crui-anchor/lib/index.js
// module id = 589
// module chunks = 0